import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";
import { Settings } from "types/SettingsTypes";

export const useUpdateSettings = (
  options?: UseMutationOptions<Settings, Error, Partial<Settings>>
) => {
  return useMutation({
    ...options,
    mutationKey: ["updateSettings"],
    mutationFn: async (variables: Partial<Settings>) => {
      return axiosInstance.put("/settings", variables).then((res) => res.data);
    },
    onSuccess: (data, variables, context) => {
      queryClient.setQueryData(["settings"], data);
      if (variables.ordersAutoSync !== undefined) {
        Toast({
          message: data.ordersAutoSync
            ? "Włączono automatyczne pobieranie zamówień z Allegro."
            : "Wyłączono automatyczne pobieranie zamówień z Allegro.",
          type: TOAST_TYPES_ENUM.SUCCESS,
          id: "update-settings",
        });
      }
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      Toast({
        message: error?.data?.message || "Błąd podczas zapisywania ustawień.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "update-settings",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useUpdateSettings;
